<script>
  import { step, commonData, selectedArea } from '../../../../../store/common';
  import { ENV } from '../../../../../core/constants/env';

  const onClick = data => {
    selectedArea.set(data);
    step.set(2);
  };
</script>

<div class="uk-modal-body">
  <h2 class="uk-modal-title">Choose Area of Interest</h2>

  <p class="uk-text-small">
    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Architecto earum
    laborum molestiae officia! Assumenda consequatur dolore dolorum eligendi est
    ex, excepturi itaque nostrum nulla porro repellat ut voluptates voluptatum?
    Explicabo.
  </p>

  <div
    class="uk-child-width-1-2 uk-child-width-1-4@s uk-grid-small"
    data-uk-grid
  >
    {#each $commonData as item}
      {#if !item.back}
        <div>
          <a
            class="uk-display-block uk-text-center"
            on:click={() => onClick(item)}
          >
            <span
              class="uk-padding-small uk-display-block uk-margin-small-bottom uk-placeholder uk-text-center uk-overflow-hidden"
            >
              <img
                class="uk-height-small"
                data-src={`${ENV.FRONT_URL}${item.icon}`}
                data-uk-img
                alt="Female face"
              />
            </span>

            <strong class="uk-text-small">{item.body_area_name}</strong>
          </a>
        </div>
      {/if}
    {/each}
  </div>
</div>
